module.exports = __webpack_public_path__ + "static/media/favico.372a8009.ico";